export var AIGeneratedContentType;
(function (AIGeneratedContentType) {
    AIGeneratedContentType[AIGeneratedContentType["INTRO"] = 0] = "INTRO";
    AIGeneratedContentType[AIGeneratedContentType["NOTE"] = 10] = "NOTE";
    AIGeneratedContentType[AIGeneratedContentType["OTHER"] = 20] = "OTHER";
})(AIGeneratedContentType || (AIGeneratedContentType = {}));
//# sourceMappingURL=article-ai-generated-content.js.map